import Button from 'react-bootstrap/Button';

function UploadButton({ onClick, className, disabled = false }) {
  return (
    <Button
      variant='primary'
      className={`d-flex align-items-center justify-content-center ${className}`}
      disabled={disabled}
      onClick={() => onClick()}
    >
      <span
        className='material-symbols-outlined me-2'
        style={{ fontSize: '18px' }}
      >
        upload
      </span>
      Ladda upp
    </Button>
  );
}

export default UploadButton;
